var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E30613"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    x: "42.16%",
    y: "20.26%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95991 7.59998C1.70017 7.59675 1.45104 7.49644 1.26153 7.31878C1.07203 7.14112 0.95587 6.89897 0.935909 6.63998L0.431909 1.39198C0.430168 1.10364 0.522892 0.822654 0.695909 0.59198C0.880136 0.368061 1.12867 0.206098 1.40791 0.12798C1.75255 0.0261876 2.11927 0.0261876 2.46391 0.12798C2.77959 0.186648 3.06359 0.357045 3.26391 0.60798C3.43693 0.838654 3.52965 1.11964 3.52791 1.40798L3.01591 6.66398C2.98981 6.92419 2.86664 7.16501 2.67094 7.33848C2.47524 7.51194 2.22137 7.60531 1.95991 7.59998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 4,
    x: "42.4%",
    y: "61.68%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01607 2.87203C2.8801 3.01226 2.71715 3.12354 2.53705 3.19915C2.35694 3.27477 2.1634 3.31316 1.96807 3.31203C1.7716 3.31287 1.57694 3.27438 1.39558 3.19881C1.21421 3.12324 1.04982 3.01213 0.912071 2.87203C0.773281 2.73538 0.663487 2.57213 0.589258 2.39206C0.51503 2.21198 0.477893 2.01879 0.480071 1.82403C0.477929 1.62803 0.514953 1.43357 0.588974 1.25207C0.662994 1.07057 0.772519 0.90568 0.911122 0.767078C1.04972 0.628475 1.21461 0.518952 1.39611 0.444931C1.57761 0.370911 1.77207 0.333886 1.96807 0.336028C2.16283 0.33385 2.35603 0.370987 2.5361 0.445215C2.71617 0.519444 2.87942 0.629237 3.01607 0.768027C3.15618 0.905772 3.26729 1.07017 3.34285 1.25154C3.41842 1.4329 3.45692 1.62755 3.45607 1.82403C3.45721 2.01936 3.41881 2.2129 3.3432 2.39301C3.26758 2.57311 3.15631 2.73605 3.01607 2.87203Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e6621dc4e96dd63969a046d4c95f6912.svg";
export { ForwardRef as ReactComponent };